import * as React from 'react';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import './InputBox.css';
export default function BasicTextFields() {
  return (
    <Box
      component="form"
      sx={{
        '& > :not(style)': { m: 1, width: '25ch' },
      }}
      noValidate
      autoComplete="off"
    >
        <div >
            <ul>
            <TextField id="outlined-basic" label="GRE Score" variant="outlined" />  
            <br/>
            <br/>
            <TextField id="outlined-basic" label="Your GPA" variant="outlined" />
            <br/>
            <br/>
            <TextField id="outlined-basic" label="ACT Score" variant="outlined" />
            <br/>
            <br/>
            <TextField id="outlined-basic" label="IELTS Score" variant="outlined" />
            <br/>
            <br/>
            <TextField id="outlined-basic" label="TOEFL Score" variant="outlined" />
            <br/>
            <br/>
            </ul>
            <ul>
            <div className='input_button'> 
            <Button variant="contained">Submit</Button>
            </div>
            </ul>
        </div>
      
      

    </Box>
    
  );
}